// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cast"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14 20H22V4H2V8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2 12C6.41828 12 10 15.5817 10 20M2 16C4.20914 16 6 17.7909 6 20M2 20H2.00391V20.0039H2V20Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CastIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cast',
    ref,
    icon: element,
  },
));

CastIcon.displayName = 'CastIcon';

export default CastIcon;
